import { httpApps } from "../helper/http-common";
class AppsColorStoneLinksService {
    GetOptionsDetails(inputdata) {
    return httpApps.post("/GemStoneLink/GetOptionsDetails", inputdata);
  }
  UpdateDiamondLinkOptionDetailsUpload(inputdata) {
    return httpApps.post(
      "/GemStoneLink/UpdateGemStoneLinkOptionDetailsUpload",
      inputdata
    );
  }

  GetMarkupLoadData(inputData, type) {
      return httpApps.post("/GemStoneLink/GetMarkupLoadData", inputData);
  }
  GetMakerGemStoneMarkupLoadData(inputData, type) {
    return httpApps.post("/GemStoneLink/GetMakerGemStoneMarkupLoadData", inputData);
  }
  GetCustomerGemStoneMarkupLoadData(inputData, type) {
     return httpApps.post("/GemStoneLink/GetCustomerGemStoneMarkupLoadData",inputData);
  }
  GetAllCostPriceAndSize(inputdata, type) {
    return httpApps.post("/GemStoneLink/GetAllCostPriceAndSize", inputdata);
  }
  UpdateAllCostPriceAndSize(inputdata, type) {
    return httpApps.post("/GemStoneLink/UpdateAllCostPriceAndSize", inputdata);
  }
  SaveGemStoneDealerMarkupdata(inputdata, type) {
    return httpApps.post("/GemStoneLink/SaveGemStoneDealerMarkupdata", inputdata);
  }
  RemoveGemStoneDealerMarkupdata(inputdata, type) {
      return httpApps.post("/GemStoneLink/RemoveGemStoneDealerMarkupdata",inputdata);
  }
  SaveGemStoneCustomMarkupdata(inputdata, type) {
    return httpApps.post("/GemStoneLink/SaveGemStoneCustomMarkupdata", inputdata);
  }
  RemoveGemStoneCustomMarkupdata(inputdata, type) {
    return httpApps.post("/GemStoneLink/RemoveGemStoneCustomMarkupdata", inputdata);
  }
  UpdateGemStoneCustomMarkupdata(inputdata, type) {
    return httpApps.post("/GemStoneLink/UpdateGemStoneCustomMarkupdata",inputdata);
  }

  //Dealers
  BindDealerList(inputData, type) {
      return httpApps.post("/GemStoneLink/BindDealerList", inputData);
  }
  ShowDataToRightNew(inputData) {
    return httpApps.post("/GemStoneLink/ShowDataToRightNew", inputData);
  }
   UpdateListClick(inputData, type) {
    if (type == "Diamond Vendor") {
      return httpApps.post(
        "/RingBuilder/UpdateList_Click_ringbuilder",
        inputData
      );
    } else {
      return httpApps.post("/GemStoneLink/UpdateList_Click", inputData);
    }
  }
}

export default new  AppsColorStoneLinksService();